var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeatherBrokenClouds = function SvgWeatherBrokenClouds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentcolor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M19.75 10.563c0-2.088-1.612-3.729-3.638-4.093C15.315 3.994 12.85 2.25 10 2.25c-2.284 0-4.312 1.119-5.44 2.831C2.152 5.485.25 7.437.25 9.875c0 2.75 2.416 4.875 5.25 4.875h9.75c2.421 0 4.5-1.816 4.5-4.187Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M23.75 17.563c0-2.127-1.73-3.749-3.84-4.098-.843-2.493-3.443-4.215-6.41-4.215-2.384 0-4.516 1.108-5.704 2.826-2.51.39-4.546 2.322-4.546 4.799 0 2.786 2.568 4.875 5.5 4.875h10.292c2.496 0 4.708-1.78 4.708-4.187Z"
  })));
};
export default SvgWeatherBrokenClouds;